import axios from 'axios';

const tradingApi = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/trading`,
});

tradingApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

// Orders
export const getOrders = (params) => tradingApi.get('/orders/', { params });
export const getOrder = (id) => tradingApi.get(`/orders/${id}/`);
export const approveOrder = (id) => tradingApi.post(`/orders/${id}/approve/`);
export const rejectOrder = (id, reason) => tradingApi.post(`/orders/${id}/reject/`, { rejection_reason: reason });
export const cancelOrder = (id) => tradingApi.post(`/orders/${id}/cancel/`);
export const modifyOrder = (id, data) => tradingApi.patch(`/orders/${id}/modify/`, data);
export const batchApprove = (orderIds) => tradingApi.post('/orders/batch-approve/', { order_ids: orderIds });
export const batchReject = (orderIds, reason) => tradingApi.post('/orders/batch-reject/', { order_ids: orderIds, rejection_reason: reason });

// Positions
export const getPositions = (params) => tradingApi.get('/positions/', { params });
export const getPosition = (id) => tradingApi.get(`/positions/${id}/`);

// Performance
export const getPerformance = (params) => tradingApi.get('/performance/', { params });
export const getPerformanceByLeague = () => tradingApi.get('/performance/by-league/');
export const getPerformanceByBetType = () => tradingApi.get('/performance/by-bet-type/');
export const getPerformanceByStrategy = () => tradingApi.get('/performance/by-strategy/');
export const getCalibration = () => tradingApi.get('/performance/calibration/');
export const getBankrollHistory = (params) => tradingApi.get('/performance/bankroll/', { params });

// Config
export const getConfig = () => tradingApi.get('/config/');
export const updateConfig = (data) => tradingApi.put('/config/', data);

// Logs
export const getLogs = (params) => tradingApi.get('/logs/', { params });

// Service
export const getHealth = () => tradingApi.get('/health/');
export const triggerScan = () => tradingApi.post('/trigger/scan/');
export const triggerPause = () => tradingApi.post('/trigger/pause/');
export const triggerResume = () => tradingApi.post('/trigger/resume/');
export const triggerExpire = () => tradingApi.post('/trigger/expire/');
export const triggerReconcile = () => tradingApi.post('/trigger/reconcile/');

export default tradingApi;
